import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6febb0a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forget-me-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary col-12 px-2 py-3 py-md-5 flex-centered-col bg-image" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "m-0 text-uppercase text-white" }, "Forget my details")
], -1))
const _hoisted_3 = { class: "py-4 py-sm-5 px-3 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you wish to remove your information from Advance, click the button bellow and send the subsequent email.", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "h4 text-white"
}
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info py-3 my-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "once the subsequent email has been sent, we will be in touch with you", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { useHead } from "@unhead/vue";
import { useUserStore } from "@/stores/user";
import { onBeforeMount, Ref, ref } from "vue";
import Spinner from "@/components/spinner/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgetMeView',
  setup(__props) {

let currentUser: Ref<any> = ref({})
let emailLink: Ref<string> = ref("")
let btnclick: Ref<boolean> = ref(false)

useHead({
  title: "Forget Me",
});

const userStore = useUserStore();
onBeforeMount(async () => {
  const profileResult = (await userStore.getProfile());
  currentUser.value = profileResult.result;
  getEmailLink();
});

function getEmailLink () {
  emailLink.value = "mailto:"
  + "support@getadvance.net"
  + "?subject=Advance - Forget Me Request"
  + `&body=A request has been made to remove the following profile from the Advance system: ${currentUser.value.email}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(btnclick) //@ts-ignore
 ? btnclick.value = true : btnclick = true)),
        class: _normalizeClass(['btn btn-primary btn-lg position-relative', {'disabled': _unref(emailLink) == ''}]),
        href: _unref(emailLink)
      }, [
        _createVNode(Spinner, {
          isAbsolute: true,
          visible: _unref(emailLink) == ''
        }, null, 8, ["visible"]),
        (_unref(emailLink) != '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Forget Me "))
          : _createCommentVNode("", true)
      ], 10, _hoisted_5),
      (_unref(btnclick))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})